import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'nio-billable-account',
    templateUrl: './billable-account.component.html',
    styleUrls: ['./billable-account.component.scss'],
    standalone: false
})
export class BillableAccountComponent implements OnInit {
  @Output() billableAccount: EventEmitter<boolean> = new EventEmitter();

  billableAccounts = true;
  constructor() { }

  ngOnInit(): void {
    this.billableAccount.emit(this.billableAccounts);
  }

  change(event) {
    console.log(event);

    this.billableAccount.emit(event?.value);
  }
}
